import React from 'react'

function Footer() {
  return (
    <div style={{position: 'fixed', bottom: 10, width: '100%', textAlign: 'center',color  : 'gray'}}>
  CC Softwares @ 2024
</div>
  )
}

export default Footer